export const RESTORE_TOKEN = "RESTORE_TOKEN";
export const LOGIN_INITIATED = "LOGIN_INITIATED";
export const LOGIN_SUCCEED = "LOGIN_SUCCEED";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGOUT = "LOGOUT";
